// extracted by mini-css-extract-plugin
module.exports = {"cls1":"AssignmentForm-Outputs-module--cls1--OKerd","cls2":"AssignmentForm-Outputs-module--cls2--2vSnB AssignmentForm-Outputs-module--cls1--OKerd"};